
import { Component, Prop, Vue } from "vue-property-decorator";
import { getChargeOptions } from "../service/ChargeService";
import { MyOption } from "../service/MyOptions.type";
import ColorPicker from "./ColorPicker.vue";
import { FillerEditorModel } from "./FillerEditorModel";
import { v4 as uuidv4 } from "uuid";

@Component({
  components: {
    ColorPicker,
  },
})
export default class FieldEditor extends Vue {
  @Prop() value!: FillerEditorModel;
  uuid = uuidv4();

  chargeOptions: MyOption[] = [];
  vairOptions = [
    { id: "vair", label: "Vair" },
    { id: "contrevair", label: "Contre-vair" },
    { id: "vair_en_pal", label: "Vair en pal" },
    { id: "vair_en_pointe", label: "Vair en pointe" },
  ];

  get color1Label(): string | null {
    switch (this.value.type) {
      case "plein":
        return "Couleur";
      case "seme":
        return "Couleur champs";
      case "pattern":
      case "strip":
        return "Couleur 1";
      case "none":
      default:
        return null;
    }
  }

  get color2Label(): string | null {
    switch (this.value.type) {
      case "seme":
        return "Couleur meuble";
      case "pattern":
      case "strip":
        return "Couleur 2";
      case "plein":
      case "none":
      default:
        return null;
    }
  }

  async mounted(): Promise<void> {
    this.chargeOptions = await getChargeOptions();
  }

  update(): void {
    this.$emit("input", this.value);
  }
}
